import log from 'loglevel';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import { get, isArray, isString, uniq } from 'lodash';
const Cookies = require('cookies-js');

export const console = log;

log.setLevel(process.env.REACT_APP_LOG_LEVEL || 'trace');

// Examples:
// log.trace('LOG_LEVEL=trace');
// log.debug('LOG_LEVEL=debug');
// log.info('LOG_LEVEL=info');
// log.warn('LOG_LEVEL=warn');
// log.error('LOG_LEVEL=error');

log.log = (msg) => {
  console.warn('[DEPRECATION] PLEASE USE `console.debug` or `log.debug` instead. See `src/utils/index.js`');
  log.info(msg);
}

export const setCookieYear = (key, value) => {
  const afterOneYear = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
  Cookies.set(key, value, {expires: afterOneYear});
}

export const setCookie = (key, value, durationInSeconds) => {
  Cookies.set(key, value, {expires: durationInSeconds});
}

export const getCookie = (key) => {
  return Cookies.get(key);
}

export const removeCookie = (key, params) => {
  return Cookies.expire(key, params);
}

export const setLocalStorage = (key, value) => {
  localStorage.setItem(key, value);
}

export const getLocalStorage = (key) => {
  return localStorage.getItem(key);
}

// This utility is for padding table data
// (2-dimenstional data representation) optionally for preparation for papaparse
export function tablePadder(data=[]) {
  let widestRow = {};
  let paddedData = [];

  // Set widest row to be based upon
  data.forEach(datum => {
    const widestRowLength = Object.keys(widestRow).length;
    const datumRowLength = Object.keys(datum).length;

    if (widestRowLength < datumRowLength) {
      widestRow = datum;
    }
  });

  // Pad 'data' based on the widest row
  paddedData = data.map(datum => {
    const widestRowKeys = Object.keys(widestRow);
    const fDatum = {};

    // Check to see if a 'datum' has widest row key and set that
    // to the final datum, else set to 'empty' string to 'pad' the datum
    widestRowKeys.forEach(widestRowKey => {
      const datumVal = datum[widestRowKey];


      if (isNaN(datumVal) && isEmpty(datumVal)) {
        fDatum[widestRowKey] = '';
      } else {
        fDatum[widestRowKey] = datumVal;
      }
    });

    return fDatum;
  });

  return paddedData;
}

export const isCustomFormValid = (errors) => {
  let isValid = true;

  for (const e in errors) {
    if (errors.hasOwnProperty(e)) {
      isValid = isEmpty(errors[e]);
      if (!isValid) break;
    }
  }

  return isValid;
}

export const mergeCustomFormErrors = (errors, customFormErrors) => {
  const customFormFieldErrors = [];

  for (const cfe in customFormErrors) {
    if (customFormErrors.hasOwnProperty(cfe)) {
      const errorsArr = customFormErrors[cfe] || [];
      customFormFieldErrors.push(...errorsArr);
    }
  }

  const uniqCustomFormFieldErrors = uniq(customFormFieldErrors);

  return {
    ...errors,
    ...customFormErrors,
    _error: [
      ...errors._error,
      ...map(
        uniqCustomFormFieldErrors,
        customFormError => ({ message: customFormError })
      ),
    ],
  }
};

export function getErrorMessage(error = {}, isUseDefMsg, msgPath) {
  if (isArray(error)) {
    return error.reduce((res, e) => {
      const msg = getErrorMessage(e, isUseDefMsg, msgPath);
      return res.concat(` ${msg}`);
    }, '');
  }

  let errorMsg = '';

  if (msgPath) {
    errorMsg = get(error, msgPath);
  } else if (isString(error)) {
    errorMsg = error;
  } else if (error.cause && error.cause.message) {
    errorMsg = error.cause.message;
  } else if (error.reason) {
    errorMsg = error.reason;
  } else if (error.errors) {
    errorMsg = getErrorMessage(error.errors);
  } else {
    errorMsg = error.message;
  }

  return !errorMsg && isUseDefMsg
    ? error.message
    : errorMsg;
}

export function checkAllGrant (prefix, feature, permissions) {
  const grants = ['create', 'read', 'update', 'delete'];
  return grants.every((g) => permissions[`${prefix}:${feature}:${g}`]);
};
